import React, { useState, useEffect } from 'react'
import AppHeader from './AppHeader'
import EncryptionInfo from './EncryptionInfo'
import LegalFieldsInfo from './LegalFieldsInfo'
import LifeUpdates from './LifeUpdates'
import ExpertsAccess from './ExpertsAccess'
import ResourcesAccess from './ResourcesAccess'
import BusniessInfo from './BusinessInfo'

const Ourapp = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    // Function to handle window resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    // Attach resize event listener
    window.addEventListener('resize', handleResize)

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, []) // Empty dependency array means this effect runs once on mount
  return (
    <>
      <div className='flex flex-col items-center gap-8 px-[20px] py-10 lg:py-15 2xl:px-0 lg:gap-15 xl:py-20 xl:gap-40 bg-[#FFFFFF0A] lg:bg-[#FFFFFF4D]'>
        <AppHeader />
        <EncryptionInfo />
      </div>
      <LegalFieldsInfo />
      <LifeUpdates isMobile={isMobile} />
      <ExpertsAccess isMobile={isMobile} />
      <BusniessInfo isMobile={isMobile} />
      <ResourcesAccess isMobile={isMobile} />
    </>
  )
}

export default Ourapp
